import {Pipe} from "@angular/core";
import * as _ from 'lodash';
import {LanguageService} from "../service/language.service";
import {Translation, translationProperty} from "../model/translation.model";

@Pipe({
  name: 'translation',
  pure: false
})
export class TranslationPipe {

  constructor() {
  }
  transform(translations: Translation[], property: translationProperty = 'name'): string {
    return LanguageService.getTranslation(translations, property);
  }

}
